// routeHelper.js
export const getRouteData = async (origin, destination) => {
  const apiKey = "8c106eebc13c45c7a5de210023569379";

  const getCoordinates = async (place) => {
    const url = `https://api.geoapify.com/v1/geocode/search?text=${encodeURIComponent(
      place
    )}&apiKey=${apiKey}`;
    const res = await fetch(url);
    const data = await res.json();
    if (data.features?.length > 0) {
      const { lat, lon } = data.features[0].properties;
      return [lat, lon];
    } else throw new Error(`Could not find location: ${place}`);
  };

  const loc1 = await getCoordinates(origin);
  const loc2 = await getCoordinates(destination);

  const url = `https://api.geoapify.com/v1/routing?waypoints=${loc1[0]},${loc1[1]}|${loc2[0]},${loc2[1]}&mode=drive&apiKey=${apiKey}`;
  const response = await fetch(url);
  const data = await response.json();

  const routeProps = data.features[0].properties;
  const distanceKm = (routeProps.distance / 1000).toFixed(2);
  const totalSeconds = routeProps.time;
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const durationMin = `${hours}h ${minutes}m`;

  return { distanceKm, durationMin };
};
